import {useMemo} from 'react'
import styled from 'styled-components'
import {
  Card, Flex, Box, Text, Button
} from '@binance/uikit'
import useOpenAccount from 'hooks/useOpenAccount'

const StyledBox = styled(Box)`
  box-sizing: border-box;
`

const Link = styled.a`
  color: #f0b90b;
  text-decoration: none;
  &:hover {
    color: #f6cb43;
  }
`

export default function OpenAccountView ({i18n}) {
  const {handleOpenAccount} = useOpenAccount(i18n)

  return useMemo(
    () => (
      <Card gridArea="orderform">
        <StyledBox width="100%" p="20px 32px">
          <Text.Base color="primary" fontSize={28} mb={16}>
            {i18n['openAccout-title'] || 'Open Future Account'}
          </Text.Base>
          <Flex color="#848E9C" fontSize={14} pb={4}>
            <img src={require('./reminderIcon.svg')} alt="" />
            &nbsp;{i18n['openAccout-reminderLabel'] || 'Reminder'}:
          </Flex>
          <Text.Base color="#848E9C" fontSize={14} lineHeight="18px">
            {i18n['openAccout-reminderContent']
              || `Futures trading is a highly risky endeavor, with the potential for both great profits and significant losses. Please be aware that in the event of extreme price movement, there is a chance that all margin balance in your futures wallet may be liquidated. Futures trading is restricted for users from certain regions.`}
          </Text.Base>
          <Button
            bg="primary"
            color="#212833"
            width="200px"
            height="40px"
            variant="large"
            mt={6}
            mb={5}
            py={0}
            ml={0}
            onClick={handleOpenAccount}
          >
            {i18n['openAccout-openBtn'] || 'Open now'}
          </Button>
          <Text.Base color="primary" fontSize={14}>
            <Link href="//binanceapitest.github.io/Binance-Futures-Documentation/" target="_blank">
              {i18n['openAccout-toTradingGuide'] || 'Click to see Future Trading Guide'}
            </Link>
          </Text.Base>
        </StyledBox>
      </Card>
    ),
    [handleOpenAccount, i18n]
  )
}
